import { Action, SimpleUiEvent } from '@storefront/types/webanalytics';

export const simpleUiEventVersion = '1.5.0';

interface UiEvents {
  [key: string]: SimpleUiEvent;
}

export const uiEvents: UiEvents = {
  errorScreenSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'ErrorScreen',
    screenMode: '',
    screenPath: '/MagentoStorefront/',
    actionAuxParams: '',
  } as SimpleUiEvent,
  errorScreenMainBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'ErrorScreen',
    screenMode: '',
    screenPath: '/MagentoStorefront/',
    controlName: 'MainAction',
    controlDetail: '',
  } as SimpleUiEvent,
  errorScreenReturnBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'ErrorScreen',
    screenMode: '',
    screenPath: '/MagentoStorefront/',
    controlName: 'ReturnHome',
  } as SimpleUiEvent,
  virtualAgentBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: '',
    screenPath: '/MagentoStorefront/',
    controlName: 'Chat',
  } as SimpleUiEvent,
  arlCheckboxBC: {
    version: simpleUiEventVersion,
    action: Action.controlToggleEnabled || Action.controlToggleDisabled,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenMode: 'Arl',
    controlName: 'AcceptTermsAndConditions',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  placeOrderBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    controlName: 'CompleteYourPayment',
    actionAuxParams: '',
  } as SimpleUiEvent,
  selectedPaymentSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'SelectedPayment',
  } as SimpleUiEvent,
  selectPaymentMethodSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'SelectPaymentMethod',
  } as SimpleUiEvent,
  selectPaymentMethodBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'SelectPaymentMethod',
  } as SimpleUiEvent,
  selectedPaymentBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'SelectedPayment',
    controlName: 'NewCard',
  } as SimpleUiEvent,
  addPaymentSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'AddPayment',
  } as SimpleUiEvent,
  addPaymentBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'AddPayment',
    controlName: '',
  } as SimpleUiEvent,
  selectShippingAddressSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'SelectShippingAddress',
  } as SimpleUiEvent,
  editAddressSelectShippingBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'SelectShippingAddress',
    controlName: 'EditAddress',
  } as SimpleUiEvent,
  addAddressSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: '',
  } as SimpleUiEvent,
  addAddressBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: '',
    controlName: '',
  } as SimpleUiEvent,
  useShippingAsBillingCT: {
    version: simpleUiEventVersion,
    action: '',
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'SelectShippingAddress',
    controlName: 'UseAsBillingAddress',
  } as SimpleUiEvent,
  printerConfigurationPageChoosePrinterSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenMode: 'ChooseYourPrinter',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  pcConfigChooseDesktopViewMoreBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'ChooseDesktopBundle',
    controlName: 'ViewMore',
  } as SimpleUiEvent,
  printerConfigurationPageSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  pcConfigurationPageSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  pCConfigurationPageFooterSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Footer',
  } as SimpleUiEvent,
  printerConfigurationPageFooterSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Footer',
  } as SimpleUiEvent,
  pCConfigurationPageFooterHLC: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenPath: '/MagentoStorefront/',
    controlDetail: '',
    screenMode: 'Footer',
  } as SimpleUiEvent,
  printerConfigurationPageFooterHLC: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    controlDetail: '',
    screenMode: 'Footer',
  } as SimpleUiEvent,
  printerConfigurationPageFooterBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    controlName: 'Chat',
    screenMode: 'Footer',
  } as SimpleUiEvent,
  printerHowItWorksBC: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'HowYourPlanWorks',
    controlName: 'LearnMore',
    controlDetail: '<URL>',
  },
  printerConfigFAQSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Faqs',
  },
  printerConfigFAQAccordianExpanded: {
    version: simpleUiEventVersion,
    action: Action.controlAccordianExpanded,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Faqs',
    controlName: 'Faq',
    controlDetail: '<FAQ_QUESTION_TRANSLATION_KEY>',
  },
  printerConfigFAQBC: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Faqs',
    controlName: 'ViewMore',
    controlDetail: '<URL>',
  },
  signOutGenericBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    controlName: 'SignOut',
    screenName: '',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  orderConfirmationSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'OrderConfirmation',
    screenPath: '/MagentoStorefront/',
    screenMode: '',
    actionAuxParams: '',
  } as SimpleUiEvent,
  orderConfirmationCT: {
    version: simpleUiEventVersion,
    action: '',
    activity: 'HpOneEnrollment-v01',
    screenName: 'OrderConfirmation',
    screenPath: '/MagentoStorefront/',
    screenMode: '',
  } as SimpleUiEvent,
  orderConfirmationHLC: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'OrderConfirmation',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  arlHyperLinkClick: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: '',
    screenMode: 'AutomaticRenewalNotice',
    screenPath: '/MagentoStorefront/',
    controlName: '',
    controlDetail: '',
  } as SimpleUiEvent,
  reviewCartControlDisplayedPC: {
    version: simpleUiEventVersion,
    action: Action.controlDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenMode: 'ReviewCart',
    screenPath: '/MagentoStorefront/',
    controlName: 'Checkout',
  } as SimpleUiEvent,
  reviewCartControlDisplayedPrinter: {
    version: simpleUiEventVersion,
    action: Action.controlDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    controlName: 'Checkout',
    screenMode: 'ReviewCart',
  } as SimpleUiEvent,
  reviewCartCheckoutPC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenMode: 'ReviewCart',
    screenPath: '/MagentoStorefront/',
    controlName: 'Checkout',
  } as SimpleUiEvent,
  reviewCartCheckoutPrinter: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    controlName: 'Checkout',
    screenMode: 'ReviewCart',
  } as SimpleUiEvent,
  reviewCartEditPC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenMode: 'ReviewCart',
    screenPath: '/MagentoStorefront/',
    controlName: 'Edit',
    controlDetail:
      'ChoosePcBundle|ChooseCapacity|ChooseDesktopBundle|ChoosePrinterBundle',
  } as SimpleUiEvent,
  reviewCartEditPrinter: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenMode: 'ReviewCart',
    screenPath: '/MagentoStorefront/',
    controlName: 'Edit',
    controlDetail: 'ChoosePrinter|ChoosePlan|ChoosePaperPlan',
  } as SimpleUiEvent,
  redirectToHpId: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'RedirectToHpId',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  backFromHpId: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'BackFromHpId',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  plusAllThisDisplayPrinter: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/',
    screenMode: 'PlusAllThis',
    screenName: 'PrinterConfigurationPage',
  } as SimpleUiEvent,
  plusAllThisDisplayPC: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/',
    screenMode: 'PlusAllThis',
    screenName: 'PcConfigurationPage',
  } as SimpleUiEvent,
  plusAllThisTile: {
    version: simpleUiEventVersion,
    action: Action.controlTileClicked,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/',
    screenMode: 'PlusAllThis',
  } as SimpleUiEvent,
  printerOrPcScreenDisplayed: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  printerConfigurationChoosePrinterBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: '',
    controlName: 'Chat',
  } as SimpleUiEvent,
  printerConfigViewMore: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    controlName: 'ViewMore',
  },
  automaticFirmwareUpdateModal: {
    version: simpleUiEventVersion,
    activity: 'HpOneEnrollment-v01',
    screenName: 'AutomaticFirmwareUpdateModal',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ChoosePrinterBundle',
  } as SimpleUiEvent,
  capacityModalDisplayed: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ChooseCapacity',
    screenName: 'HowMuchStorageDoYouNeedModal',
  } as SimpleUiEvent,
  googleStorageModalDisplayed: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ChooseGoogleOneStorage',
    screenName: 'HowMuchGoogleOneCloudStorageDoYouNeedModal',
  } as SimpleUiEvent,
  connectivityModalDisplayed: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ChooseConnectivity',
    screenName: 'DifferenceBetweenWifiOnlyAndFiveGenModal',
  } as SimpleUiEvent,
  comparePrintersModalDisplayed: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PrinterConfigurationPage/',
    screenMode: 'ChooseYourPrinter',
    screenName: 'PrinterComparisonModal',
  } as SimpleUiEvent,
  needMorePlanInfoModalDisplayed: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PrinterConfigurationPage/',
    screenMode: '',
    screenName: 'PrinterConfigurationPage',
  } as SimpleUiEvent,
  termsOfServiceAddPaperModalButtonClicked: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenMode: 'AddPaper',
    screenName: 'WhatIsPaperAddOnModal',
  } as SimpleUiEvent,
  printerModalDisplayed: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ChoosePrinterBundle',
    screenName: 'WhatsInThePrinterPlan',
  } as SimpleUiEvent,
  printerModalClicked: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'WhatsInThePrinterPlan',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ChoosePrinterBundle',
    controlName: 'NextBusinessDayReplacement',
    controlDetail: '<URL>',
  } as SimpleUiEvent,
  unsupportedDeliveryModalDisplayed: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/CheckoutOnePage/',
    screenName: 'UnsupportedDeliveryModal',
  } as SimpleUiEvent,
  unsupportedDeliveryButtonClicked: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/CheckoutOnePage/',
    screenName: 'UnsupportedDeliveryModal',
  } as SimpleUiEvent,
  printerFullSpecsClicked: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'ChoosePrinterBundle',
    controlName: 'FullSpecs',
    controlDetail: '<URL>',
  } as SimpleUiEvent,
  pcConfigurationFullSpecs: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/',
    screenName: 'PcConfigurationPage',
    controlName: 'FullSpecs',
    controlDetail: '',
  } as SimpleUiEvent,
  disclaimerModalWD: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'DisclaimerModal',
    screenPath: '<SCREEN_PATH>',
    screenMode: 'Footer',
  } as SimpleUiEvent,
  disclaimerSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Disclaimer',
  } as SimpleUiEvent,
  disclaimerPrinterSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Disclaimer',
  } as SimpleUiEvent,
  disclaimerGenericHLC: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PcConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Disclaimer',
    controlName: '',
  } as SimpleUiEvent,
  disclaimerGenericHLCprinter: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Disclaimer',
    controlName: '',
  } as SimpleUiEvent,
  faqGenericHLCprinter: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Faqs',
    controlName: '',
  } as SimpleUiEvent,
  fullSpecsGenericHLC: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterComparisonModal',
    screenPath: '/MagentoStorefront/PrinterConfigurationPage/',
    screenMode: 'ChooseYourPrinter',
    controlName: '',
    controlDetail: '',
  } as SimpleUiEvent,
  plusAllThis: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PlusAllThis',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: '',
    controlName: 'LearnMore',
    controlDetail: '',
  } as SimpleUiEvent,
  printerBundleDynamicSecurity: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ChoosePrinterBundle',
    screenName: 'AutomaticFirmwareUpdateModal',
    controlName: 'DynamicSecurity',
    controlDetail: '',
  } as SimpleUiEvent,
  printerBundleHpOnePrivacy: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ChoosePrinterBundle',
    screenName: 'AutomaticFirmwareUpdateModal',
    controlName: 'HpOnePrivacy',
    controlDetail: '',
  } as SimpleUiEvent,
  modalFinanceCpRatesAndFeesInfo: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenPath: '/MagentoStorefront/PcConfigurationPage/',
    screenMode: 'ReviewCart',
    screenName: 'WithCitizensPayModal',
    controlName: 'CpRatesAndFeesInfo',
    controlDetail: '',
  } as SimpleUiEvent,
  betaProgramScreenDisplay: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'BetaProgramPage',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  summaryPageSD: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'SummaryPage',
    screenPath: '/MagentoStorefront/',
  } as SimpleUiEvent,
  summaryPageEditBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'SummaryPage',
    screenPath: '/MagentoStorefront/',
    controlName: 'Edit',
  } as SimpleUiEvent,
  summaryPageAfuToggle: {
    version: simpleUiEventVersion,
    action: Action.controlToggleEnabled || Action.controlToggleDisabled,
    activity: 'HpOneEnrollment-v01',
    screenName: 'SummaryPage',
    screenPath: '/MagentoStorefront/',
    controlName: 'AutoFirmwareUpdatesPrinter',
  },
  summaryPageAfuLearnLink: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'SummaryPage',
    screenPath: '/MagentoStorefront/',
  },
  summaryPagePaperBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'SummaryPage',
    screenPath: '/MagentoStorefront/',
    controlName: '',
  } as SimpleUiEvent,
  summaryPageBackBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'SummaryPage',
    screenPath: '/MagentoStorefront/',
    controlName: 'Back',
  } as SimpleUiEvent,
  summaryPageCheckoutBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'SummaryPage',
    screenPath: '/MagentoStorefront/',
    controlName: 'Checkout',
  } as SimpleUiEvent,
  footerLinksBC: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: '<SCREEN_NAME>',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Footer',
    controlName: '<LINK_NAME>',
    controlDetail: '<URL>',
  } as SimpleUiEvent,
  errorModuleDisplayed: {
    version: simpleUiEventVersion,
    action: Action.moduleDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'ErrorComponent',
    screenMode: '',
    screenPath: '',
    actionAuxParams: '',
  } as SimpleUiEvent,
  breadcrumbEvent: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'Breadcrumb',
    controlName: '',
    controlDetail: '',
  } as SimpleUiEvent,
  abandonCartButton: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'AbandonCart',
    screenPath: '',
    controlName: '',
  } as SimpleUiEvent,
  abandonCartDisplay: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'AbandonCart',
    screenPath: '',
  } as SimpleUiEvent,
  saveAddressButton: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    controlName: 'SaveAddress',
    screenPath: `/MagentoStorefront/CheckoutOnePage/`,
    screenMode: 'ModalSuggestion',
    screenName: 'AddShippingAddress',
  } as SimpleUiEvent,
  reviewSubscriptions: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'AlreadyHaveInstantInk',
    actionAuxParams: '',
  } as SimpleUiEvent,
  handleSubscriptionsReview: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'AlreadyHaveInstantInk',
    controlName: '',
  } as SimpleUiEvent,
  goToMyAccountReview: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'AlreadyHaveInstantInk',
    controlName: 'MyAccount',
    controlDetail: '',
  } as SimpleUiEvent,
  instantInkModal: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CancelInstantInkModal',
    controlName: '',
  } as SimpleUiEvent,
  reviewSubscriptionFooter: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'AlreadyHaveInstantInk',
    controlName: 'FooterMyAccount',
    controlDetail: '',
  } as SimpleUiEvent,
  whatHappensInstantInkCancel: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'AlreadyHaveInstantInk',
    controlName: 'WhatHappensInstantInkCancel',
    controlDetail: '',
  } as SimpleUiEvent,
  instantInkDashboard: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CancelInstantInkModal',
    screenMode: 'InstanInkDashboard',
    controlName: 'InstanInkDashboard',
    controlDetail: '',
  } as SimpleUiEvent,
  promoCodeEvents: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'CheckoutOnePage',
    controlName: '',
  } as SimpleUiEvent,
  sessionExpiredEvent: {
    version: simpleUiEventVersion,
    action: Action.modalWindowDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'ExpiredTokenModalError',
    screenMode: 'SessionExpired',
  } as SimpleUiEvent,
  addPaperChatBC: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'AddPaper',
    controlName: 'Chat',
  } as SimpleUiEvent,
  addPaperDisplayed: {
    version: simpleUiEventVersion,
    action: Action.screenDisplayed,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'AddPaper',
  } as SimpleUiEvent,
  addPaperHyperLinkClicked: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'PrinterConfigurationPage',
    screenPath: '/MagentoStorefront/',
    screenMode: 'AddPaper',
    controlName: 'modal-add-paper-hp-one-privacy-link',
    controlDetail: '',
  } as SimpleUiEvent,
  modalInkPaperOption: {
    version: simpleUiEventVersion,
    action: Action.controlToggleEnabled || Action.controlToggleDisabled,
    activity: 'HpOneEnrollment-v01',
    screenName: 'HelpMeChooseInkModal',
    screenPath: '/MagentoStorefront/PrinterConfigurationPage/',
    screenMode: 'ChooseYourPagePlan',
    controlName: 'ShowPaperAddon',
  },
  modalInkModelOption: {
    version: simpleUiEventVersion,
    action: Action.controlButtonClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'HelpMeChooseInkModal',
    screenPath: '/MagentoStorefront/PrinterConfigurationPage/',
    screenMode: 'ChooseYourPagePlan',
    controlName: 'PrintPlans',
    controlDetail: '',
  },
  checkoutDisclaimerModalWindows: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'DisclaimerModal',
    screenPath: '/MagentoStorefront/CheckoutOnePage/',
    screenMode: 'Footer',
    controlName: 'Windows',
  },
  checkoutDisclaimerModaPrivacyStatement: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'DisclaimerModal',
    screenPath: '/MagentoStorefront/CheckoutOnePage/',
    screenMode: 'Footer',
    controlName: 'PrivacyStatement',
  },
  checkoutDisclaimerModalLearnAboutSupplies: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'DisclaimerModal',
    screenPath: '/MagentoStorefront/CheckoutOnePage/',
    screenMode: 'Footer',
    controlName: 'LearnAboutSuplies',
  },
  checkoutDisclaimerModalHPBestEveryDayPrintQuality: {
    version: simpleUiEventVersion,
    action: Action.controlHyperLinkClicked,
    activity: 'HpOneEnrollment-v01',
    screenName: 'DisclaimerModal',
    screenPath: '/MagentoStorefront/CheckoutOnePage/',
    screenMode: 'Footer',
    controlName: 'HPBestEveryDayPrintQuality',
  },
};
